import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { GripVertical, Trash2, Plus } from 'lucide-react';

const ICON_OPTIONS = ['Award', 'Star', 'BookOpen', 'GraduationCap', 'Heart', 'Target', 'Lightbulb', 'Pen', 'Trophy', 'Globe', 'Sparkles', 'Users'];
const ALIGN_OPTIONS = [{ value: 'right', label: 'يمين' }, { value: 'center', label: 'وسط' }, { value: 'left', label: 'يسار' }];

const FeaturesEditor = ({ data, setData }) => {
  const items = data.items || [];
  const update = (newItems) => setData({ ...data, items: newItems });

  return (
    <div className="space-y-4">
      {items.map((item, i) => (
        <Card key={i} className="p-4">
          <div className="flex items-start gap-3">
            <GripVertical className="w-5 h-5 text-gray-400 mt-2 shrink-0" />
            <div className="flex-1 space-y-2">
              <Input value={item.title || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], title: e.target.value }; update(n); }} placeholder="عنوان الميزة" data-testid={`feat-title-${i}`} />
              <textarea value={item.description || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], description: e.target.value }; update(n); }} placeholder="وصف الميزة..."
                className="w-full border rounded-lg p-2 text-sm min-h-[60px] resize-none focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none" data-testid={`feat-desc-${i}`} />
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className="text-xs text-muted-foreground mb-1 block">الأيقونة</label>
                  <select value={item.icon || 'Award'} onChange={e => { const n = [...items]; n[i] = { ...n[i], icon: e.target.value }; update(n); }}
                    className="w-full border rounded-lg p-2 text-sm" data-testid={`feat-icon-${i}`}>
                    {ICON_OPTIONS.map(ic => <option key={ic} value={ic}>{ic}</option>)}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="text-xs text-muted-foreground mb-1 block">نسق النص</label>
                  <div className="flex gap-1">
                    {ALIGN_OPTIONS.map(opt => (
                      <button key={opt.value} type="button" onClick={() => { const n = [...items]; n[i] = { ...n[i], align: opt.value }; update(n); }}
                        className={`flex-1 py-1.5 text-xs rounded-lg border transition-all ${(item.align || 'right') === opt.value ? 'bg-primary text-white border-primary' : 'border-gray-200 hover:border-gray-300'}`}>
                        {opt.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <button onClick={() => update(items.filter((_, j) => j !== i))} className="text-red-400 hover:text-red-600 mt-2"><Trash2 className="w-5 h-5" /></button>
          </div>
        </Card>
      ))}
      <Button variant="outline" onClick={() => update([...items, { title: '', description: '', icon: 'Award', align: 'right' }])} className="w-full" data-testid="add-feature">
        <Plus className="w-4 h-4 ml-2" /> إضافة ميزة
      </Button>
    </div>
  );
};

export default FeaturesEditor;
